import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import singimage from '../../assets/images/ETherapy_Purple.png';
import Feedspace from '../Feedspace';
import { feedspace_id_dashboard, E_THERAPY_HOME_URL } from '../../config/Constants';
import { sendAmplitudeData } from '../../utilities/amplitude';

export default function Footer() {
  const location = useLocation();
  const { pathname } = location;
  const user = useSelector((state) => state.user);
  const roleId = user?.role?.id;
  const [showEtherapyLogo, setShowEtherapyLogo] = useState(false);

  useEffect(() => {
    const noEtherapyLogoScreens = ['/school/dashboard', '/school/staff', '/school/staff/*', '/admin/*'];
    const isDynamicRoute = noEtherapyLogoScreens.find((route) => {
      const routeParts = route.split('/');
      const pathParts = pathname.split('/');
      if (routeParts.length === pathParts.length) {
        return routeParts.every((routePart, index) => {
          if (routePart === '*') {
            return true;
          }
          return routePart === pathParts[index];
        });
      }
      return false;
    });
    if (isDynamicRoute) {
      setShowEtherapyLogo(false);
    } else {
      setShowEtherapyLogo(true);
    }
  }, [pathname]);

  return (
    <>
      {roleId ? (
        <div className="sing-box">
          {showEtherapyLogo && (
            <div className="sing-box-inner">
              <div className="sign-info">
                <a
                  href="https://www.electronic-therapy.com/contact-us/"
                  title="Electronic-Therapy.com"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => {
                    sendAmplitudeData(`Get E-Therapy Services for My School`, {});
                  }}
                >
                  Get E-Therapy Services for My School
                </a>
              </div>
              <div className="sing-logo">
                <img src={singimage} alt="Logo" />
              </div>
            </div>
          )}
        </div>
      ) : (
        ''
      )}

      <footer className="footer">
        <div>
          <span>
            © {new Date().getFullYear()} eQUIP by{' '}
            <a
              className="z-index-100-with-pos"
              href={E_THERAPY_HOME_URL}
              target="_blank"
              rel="noreferrer"
              title="https://www.electronic-therapy.com"
            >
              E-Therapy
            </a>
          </span>
        </div>

        <div>
          <nav className="nav" />
        </div>
        {roleId ? <Feedspace feedspaceTitle="Give us Feedback" feedspaceId={feedspace_id_dashboard} /> : ''}
      </footer>
    </>
  );
}
